const type = [
  {id: 'update', name: '업데이트'},
  {id: 'fix', name: '버그 수정'},
  {id: 'notice', name: '기타 공지'}
]

export default {
  type
}
